import Cookies from "js-cookie";

const fifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);

const generateCookies = pin => {
  Cookies.set("pin", pin, { expires: fifteenMinutes });
};

const removeCookies = () => {
  Cookies.remove("pin");
};

const checkCookies = () => {
  return Cookies.get("pin") !== undefined;
};

const getCookies = () => {
  return Cookies.get("pin");
};

export default {
  generateCookies,
  removeCookies,
  checkCookies,
  getCookies,
};
